import { type ComponentPropsWithoutRef, forwardRef } from "react"

export type OverlayProps = ComponentPropsWithoutRef<"div"> & {
  /**
   * Indicates the area that the `<Overlay />` should occupy. Either its container
   * (parent) or the entire screen.
   *
   * @default container
   */
  "data-area"?: "container" | "screen"
}

export const Overlay = forwardRef<HTMLDivElement, OverlayProps>(
  ({ className, ...restProps }, ref) => {
    return (
      <div ref={ref} {...restProps} className={`overlay ${className ?? ""}`} />
    )
  },
)

Overlay.displayName = "Overlay"
